import { render } from "./AdminAI.vue?vue&type=template&id=e64a32ee&scoped=true"
import script from "./AdminAI.vue?vue&type=script&lang=js"
export * from "./AdminAI.vue?vue&type=script&lang=js"

import "./AdminAI.vue?vue&type=style&index=0&id=e64a32ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64a32ee"]])

export default __exports__